<template>
    <div class="pagination" v-if="pagesCount > 1">
        <span class="pagination__line"></span>
        <div class="pagination__inner">
            <div @click="back" class="pagination__item pagination__icon pagination__icon--back" v-if="currentPage > 1">
                <button>
                    <svg class="icon text-default-400 stroke-current">
                        <use xlink:href="/img/sprites/icons-sprite.svg#icon-pagination"></use>
                    </svg>
                </button>
            </div>
            <div class="pagination__item"
                 @click="setPage(page)"
                 v-for="page in range" :key="page"
                 :class="{'!bg-default': currentPage === page}"> {{ page }}
            </div>
            <div @click="next" class="pagination__item pagination__icon"
                 v-if="pagesCount > 1 && !(+currentPage === +pagesCount)">
                <button type="button">
                    <svg class="icon text-default-400 stroke-current">
                        <use xlink:href="/img/sprites/icons-sprite.svg#icon-pagination"></use>
                    </svg>
                </button>
            </div>
        </div>
        <span class="pagination__line"></span>
    </div>
</template>

<script setup>
import {defineProps, defineEmits, computed, ref, onMounted, watch} from "vue";

const pagesCount = ref(1);
const props = defineProps({
    count: {
        default: () => {
            return 1
        }
    },
    pageSize: {
        type: Number,
        default: 10
    },
    scrollTo: {
        type: String,
        default: () => '#app'
    }
});
const recalculatePages = () => {
    pagesCount.value = Math.ceil(props.count / props.pageSize)
    currentPage.value = 1;
    emits('update', currentPage.value)
}

watch(() => props.count, () => {
    recalculatePages()
})

onMounted(() => {
    recalculatePages()
})

const emits = defineEmits(['update'])
const currentPage = ref(1);
const range = computed(() => {
    const pages = [];
    if (pagesCount.value < 6) {
        for (let i = 1; i <= pagesCount.value; i++) {
            pages.push(i)
        }
        return pages
    }
    const start = currentPage.value > 4 ? currentPage.value - 2 : currentPage.value;
    const end = Math.min(pagesCount.value, currentPage.value + 2);
    for (let i = start; i <= end; i++) {
        pages.push(i)
    }
    if (currentPage.value > 1) {
        pages.unshift('...')
        pages.unshift(1)
    }
    if (currentPage.value < pagesCount.value - 3) {
        pages.push('...')
        pages.push(pagesCount.value)
    }
    return pages

})
const scroll = () => {
    document.querySelector(props.scrollTo).scrollIntoView({ behavior: "smooth", block: 'start' })
    // window.scrollTo({ behavior: "smooth", top: "0" })
}

const next = () => {
    if (currentPage.value + 1 > pagesCount.value)
        return
    currentPage.value++;
    scroll()
    emits('update', currentPage.value)
}

const back = () => {
    if (currentPage.value - 1 <= 0)
        return
    currentPage.value--;
    scroll()
    emits('update', currentPage.value)
}

const setPage = (page) => {
    if (page === '...') return
    currentPage.value = page
    scroll()
    emits('update', currentPage.value)
}


</script>


<style lang="scss" scoped>
@import './scss/pagination.scss';
</style>
